import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Authors from "./views/Authors.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/authors",
      name: "authors",
      component: Authors
    },
    {
      path: "/insert",
      name: "insert",
      // route level code-splitting
      // this generates a separate chunk (insert.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "insert" */ "./views/Insert.vue")
    },
    {
      path: "/library",
      name: "library",
      beforeRouteEnter: (to, from, next) => {
        //controlla cookie
        //debugger
        // eslint-disable-next-line no-undef
        // var cookieJwt = $cookies.get("jwt");
        // if (!cookieJwt) {
        //   next("/");
        // }
        next();
      },
      component: () =>
        import(/* webpackChunkName: "library" */ "./views/Library.vue")
    },
    {
      path: "/details/:id",
      name: "details",
      props: true,
      component: () =>
        import(/* webpackChunkName: "details" */ "./views/Details.vue")
    },
    {
      path: "/error",
      name: "error",
      props: true,
      component: () =>
        import(/* webpackChunkName: "error" */ "./views/Error.vue")
    },
    {
      // will match everything
      path: "*",
      props: {
        error: {
          status: 404,
          statusText: "Not Found",
          data: ""
        }
      },
      component: () =>
        import(/* webpackChunkName: "error" */ "./views/Error.vue")
    }
  ]
});
